import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=2ad1245c&"
import script from "./create-product.vue?vue&type=script&lang=ts&"
export * from "./create-product.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports